/** Small measures the scene's parts share: node sizes and distances on screen. */
import { NODE_RADIUS, PICTURE_RADIUS } from "./constants";

/**
 * How big a node is drawn (world units), from its number of links: the more a node is linked,
 * the bigger it is, whatever its kind. It grows with the square root, so hubs stand out
 * without swallowing the picture. A node showing a picture (`picture`) is at least
 * {@link PICTURE_RADIUS}.
 */
export function nodeRadius(degree: number, picture = false): number {
  const r = NODE_RADIUS + Math.sqrt(degree) * 3;
  return picture ? Math.max(r, PICTURE_RADIUS) : r;
}

/** Distance from a point to a segment. */
export function segmentDistance(px: number, py: number, x1: number, y1: number, x2: number, y2: number): number {
  const dx = x2 - x1;
  const dy = y2 - y1;
  const l2 = dx * dx + dy * dy;
  let t = l2 ? ((px - x1) * dx + (py - y1) * dy) / l2 : 0;
  t = Math.max(0, Math.min(1, t));
  return Math.hypot(px - (x1 + t * dx), py - (y1 + t * dy));
}
